import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Icon from '../../../Atoms/Icon/Icon';
import Switch from '../../../Atoms/Switch/Switch';
import useSmallScreen from '../../../lib/hooks/useSmallScreen';
import {
  getAltBackupPortIcons,
  getIsConnected,
} from '../../TerminalHome/Wan/connection';
import Content from '../../TerminalHome/Wan/Content';

const OtherSettings = ({
  port,
  connectionStatus,
  readOnly = false,
  loading,
  active,
  onStatusChange,
}) => {
  const isSmallScreen = useSmallScreen('sm');
  return (
    <Row
      className={
        isSmallScreen ? 'd-flex justify-content-center border' : 'border'
      }
    >
      <Col xl={3}>
        <Content
          icon={
            <Icon
              className="mt-2"
              style={{ fontSize: '2.42rem' }}
              name={getAltBackupPortIcons(connectionStatus)}
            />
          }
          line1={port || '---'}
          line2={connectionStatus || '---'}
          line2ClassName={classNames(
            getIsConnected(connectionStatus) ? 'text-green' : 'text-gray-500',
            'text-uppercase',
          )}
        />
        <div className="text-center mb-5">
          {!readOnly && (
            <Switch
              name="switch"
              disabled={loading}
              checked={active}
              onChange={onStatusChange}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

OtherSettings.propTypes = {
  connectionStatus: PropTypes.string,
  port: PropTypes.string,
  readOnly: PropTypes.bool,
  loading: PropTypes.bool,
  active: PropTypes.bool,
  onStatusChange: PropTypes.func,
};

export default OtherSettings;
